import axios from 'axios';

import { MediaType, IRandomAccessDataSource } from '@colibrio/colibrio-reader-framework/colibrio-core-io-base';

export interface HttpDataSourceOptions {
  url: string;
  size: number;
  type: MediaType;
}

export class HttpDataSource<O extends HttpDataSourceOptions> implements IRandomAccessDataSource {
  constructor(protected options: O) {}

  static async getOptionsFromUrl(url: string): Promise<HttpDataSourceOptions> {
    const response = await axios.head(url);

    const size = parseInt(response.headers['content-length']);
    let type = response.headers['content-type'] as MediaType;

    // Fallback: detect media type from URL extension if server returns generic content-type
    if ((type as string) === 'application/octet-stream' || !type) {
      const urlWithoutQuery = url.split('?')[0];
      if (urlWithoutQuery.endsWith('.epub')) {
        type = MediaType.APPLICATION_EPUB_ZIP;
      } else if (urlWithoutQuery.endsWith('.pdf')) {
        type = MediaType.APPLICATION_PDF;
      } else {
        throw new Error(`Unsupported media type. Only EPUB and PDF files are supported.`);
      }
    }

    return { url, size, type };
  }

  getType(): MediaType {
    return this.options.type;
  }

  getSize(): number {
    return this.options.size;
  }

  async fetchChunk(startOffset: number, endOffset: number): Promise<ArrayBuffer> {
    return await axios
      .get<ArrayBuffer>(this.options.url, {
        headers: { range: `bytes=${startOffset}-${endOffset - 1}` },
        responseType: 'arraybuffer'
      })
      .then(({ data }) => data);
  }
}
